export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/de.0f5726fe.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};